module.exports = __webpack_public_path__ + "static/media/mgen.8ce2f4eb.png";